import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { fg } from '@atlassian/jira-feature-gating';

import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

import { fetchAvpPermissionsGetCapabilities } from './fetchAvpPermissionsGetCapabilities.tsx';

const RESOURCE_TYPE_AVP_CAPABILITY_CONFIG = 'AVP_CAPABILITY_CONFIG' as const;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const capabilitiesConfigResource: RouteResource<any> = createResource({
	type: RESOURCE_TYPE_AVP_CAPABILITY_CONFIG,
	getKey: (_, { tenantContext: { activationId, cloudId } }) => {
		return activationId && cloudId ? JSON.stringify({ activationId, cloudId }) : '-none-';
	},
	isBrowserOnly: true,
	getData: async (_, { tenantContext: { activationId, cloudId } }) => {
		const __startTime = fg('platform_avp_custom-fetch-spans_dashboard') ? performance.now() : null;
		try {
			if (!activationId) {
				throw new Error('Route config is missing activation ID');
			}
			if (!cloudId) {
				throw new Error('Route config is missing cloud ID');
			}
			const data = await fetchAvpPermissionsGetCapabilities(activationId, cloudId);
			return __startTime
				? { ...data, __metadata: { startTime: __startTime, endTime: performance.now() } }
				: data;
		} catch (error) {
			throw createResourceError(
				{
					component: 'spa.view.routes.viz-platform.getData',
					message: 'Error fetching capabilities',
					name: 'ResourceError',
				},
				error,
			);
		}
	},
	maxAge: 60_000,
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const useCapabilitiesConfig = (): UseResourceHookResponse<any> =>
	useResource(capabilitiesConfigResource);
